import * as React from 'react';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Badge, Button, Grid, IconButton, MenuItem, useScrollTrigger } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { paths } from '../config/router.config';
import { useHistory } from 'react-router-dom';
import { getData, logOut } from '../utils/commons';
import MenuIcon from '@mui/icons-material/Menu';
import { LogoutIcon, EmailWhiteIcon, ProfileIcon } from './CustomIcons';
import { useTranslation } from 'react-i18next';
import { common } from '@mui/material/colors';
import wsclients from '../services/wsclients';
import { portalCfg } from '../config';

const logoImage = portalCfg.publicPath + "/images/logo.png";
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, isToken, nomargin }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    background: 'transparent',
    boxShadow: 'none',
    ...(isToken && {
        background: theme.palette.primary.main,
        // marginLeft: `calc(${theme.spacing(7)} + 1px)`,
        // width: `calc(100% - ${theme.spacing(7)} + 1px)`,
        width: '100%'
    }),
    ...(nomargin && {
        background: theme.palette.primary.main,
        width: '100%',
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        background: theme.palette.primary.main,
    }),
}));
const useStyles = makeStyles((theme) => ({
    toolbar: {
        // paddingLeft: theme.spacing(40),
        // paddingRight: theme.spacing(40),
        width: '70%',
        marginLeft: '15%',
        marginRight: '15%',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        [theme.breakpoints.down('lg')]: {
            width: '96%',
            marginLeft: '2%',
            marginRight: '2%',
        },
        [theme.breakpoints.down('md')]: {
            width: '96%',
            marginLeft: '2%',
            marginRight: '2%',
        },
    },
    logo: {
        cursor: 'pointer',
        height: theme.spacing(8),
        [theme.breakpoints.down('lg')]: {
            height: theme.spacing(6),
        },
        [theme.breakpoints.down('md')]: {
            height: theme.spacing(5),
        },
    },
    notificationIcon: {
        padding: theme.spacing(0, 2)
    }
}));

const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
    minHeight: theme.spacing(6) + '!important',
}));

export default function CustomHeader(props) {
    const {open, handleDrawer, nomargin, hideMenu} = props;
    // console.log("props CustomHeader===", props);
    const {t} = useTranslation();
    const [numberNotify, setNumberNotify] = React.useState(null);
    const history = useHistory();

    const onLogin = () => {
        history.push(paths.login);
    }
    const onLogOut = () => {
        logOut();
    }

    const goToHome = () => {
        history.push(paths.home);
    }
    const onNotifications = () => {
        history.push(paths.notifications);
        props.setMenuSelected(null);
    }
    const onProfile = () => {
        history.push(paths.setting)
    }

    const classes = useStyles();
    const profileName = wsclients.getSession();
    var token = getData();
    if (!token) {
        return (
            <ScrollHandler>
                <AppBar position="fixed" open={open}>
                    <Toolbar disableGutters classes={{ root: classes.toolbar }}>
                        <img src={logoImage} alt="Logo" className={classes.logo} onClick={goToHome} />
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />
                        {!props.hideSignIn && <Button color="inherit" onClick={onLogin}>
                            <Typography variant="body2">SIGN IN</Typography>
                        </Button>}
                    </Toolbar>
                </AppBar>
            </ScrollHandler>
        )
    } else {
        return (
            <>
                <AppBar position="fixed" open={open} isToken={token ? true : false} nomargin={nomargin}>
                    <Toolbar>
                        {!hideMenu ? <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawer}
                            edge="start"
                            sx={{
                                marginRight: '36px',
                            }}
                        >
                            <MenuIcon />
                        </IconButton> : <>
                        <Typography variant="subtitle1" color={common.white}>{profileName && profileName.preferred_username ? profileName.preferred_username : ""}</Typography>
                        </>}
                        <div style={{flex: 1}}></div>
                        {/* <Grid item className={classes.notificationIcon}>
                            <IconButton onClick={() => onProfile()}>
                                <ProfileIcon />
                            </IconButton>
                        </Grid> */}
                        {/* <Grid item className={classes.notificationIcon}>
                            <IconButton onClick={() => onNotifications('notifications')}>
                                <Badge badgeContent={numberNotify} classes={{ badge: classes.badgeColorPrimary }}>
                                    <EmailWhiteIcon />
                                </Badge>
                            </IconButton>
                        </Grid> */}
                        <IconButton onClick={() => onLogOut()}>
                            <LogoutIcon />
                            <Typography variant='body2' color={common.white} style={{paddingLeft: 5}}>{t('btn_log_out')}</Typography>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                
            </>
        );
    }
}

const ScrollHandler = props => {
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: props.window ? window() : undefined
    });

    return React.cloneElement(props.children, {
        style: {
            backgroundColor: trigger ? "#ffffff" : "transparent",
            color: trigger ? "black" : "#ffffff",
            transition: trigger ? "0.3s" : "0.5s",
            boxShadow: "none",
        }
    })
};